<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.QueryLCLJobOrder2')"
      width="1085px"
      append-to-body
      :close-on-click-modal="false"
      class="app-main-inner search"
    >
      <div v-if="isFba" class="app-main-inner-row">
        <search-item
          config-module="10013"
          :reset="true"
          :show-simple="false"
          :expand-adv="true"
          :col-settings="{span:8}"
          :custom-search-items="customSearchItems"
          @advSearchItemCallBack="toQueryForFba"
        />
      </div>
      <div v-if="!isFba" class="app-main-inner-row">
        <!--        CARGO-28997 【加入小票】优化前端提示-->
        <!--        <div class="filters">-->
        <!--          <el-form label-width="85px" label-position="left">-->
        <!--            <el-row :gutter="10">-->
        <!--              <el-col :span="8">-->
        <!--                <el-form-item :label="$t('CargoMsg.Cargo_BusinessNo')">-->
        <!--                  <el-input v-model="filter.jobNo" />-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--              <el-col :span="8">-->
        <!--                <el-form-item :label="$t('CargoMsg.Cargo_AirlineCompany')">-->
        <!--                  <cargo-company-select-->
        <!--                    :method-params="{companyLob:'airExport',airCmp:true,active:true}"-->
        <!--                    :default-value="filter.carrierId||''"-->
        <!--                    @change="p=>{filter.carrierId=p.value}"-->
        <!--                  />-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--              <el-col :span="8">-->
        <!--                <el-form-item :label="$t('CargoMsg.Cargo_Flight')">-->
        <!--                  <el-input v-model="filter.flight" />-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--            </el-row>-->

        <!--            <el-row :gutter="10">-->
        <!--              <el-col :span="8">-->
        <!--                <el-form-item :label="$t('CargoMsg.Cargo_AuthorizedClient')">-->
        <!--                  <cargo-company-select-->
        <!--                    :method-params="{customer:true,companyLob:'seaExport',active:true}"-->
        <!--                    :default-value="filter.customerId||''"-->
        <!--                    @change="p=>{filter.customerId=p.value}"-->
        <!--                  />-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--              <el-col :span="8">-->
        <!--                <el-form-item :label="$t('SeaExport.LoadingPort')">-->
        <!--                  <cargo-advance-select-->
        <!--                    :select-type="selectTypeNames.basic_data_Airport"-->
        <!--                    filterable-->
        <!--                    :default-value="filter.loadingPortCode"-->
        <!--                    @parentCallBack="p=>{filter.loadingPortCode=p.value}"-->
        <!--                  />-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--              <el-col :span="8">-->
        <!--                <el-form-item :label="$t('SeaExport.PortOfDestination')">-->
        <!--                  <cargo-advance-select-->
        <!--                    :select-type="selectTypeNames.basic_data_Airport"-->
        <!--                    filterable-->
        <!--                    :default-value="filter.destinationPortCode"-->
        <!--                    @parentCallBack="p=>{filter.destinationPortCode=p.value}"-->
        <!--                  />-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--            </el-row>-->
        <!--            <el-row :gutter="10">-->
        <!--              <el-col :span="24">-->
        <!--                <el-form-item :label="$t('CargoMsg.Cargo_SailingDate')" class="custom-date">-->
        <!--                  <div style="display: flex;justify-content: space-between; width: 258px;">-->
        <!--                    <el-date-picker-->
        <!--                      v-model="filter.etdStart"-->
        <!--                      type="date"-->
        <!--                      value-format="yyyy-MM-dd"-->
        <!--                    />-->
        <!--                    <span style="font-size: 12px;margin-left: 1px;margin-right: 1px;">-</span>-->
        <!--                    <el-date-picker-->
        <!--                      v-model="filter.etdEnd"-->
        <!--                      type="date"-->
        <!--                      clearable-->
        <!--                      value-format="yyyy-MM-dd"-->
        <!--                    />-->
        <!--                  </div>-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--            </el-row>-->
        <!--            <el-form-item class="custom">-->
        <!--              <el-button style="margin-left: -85px;" type="primary" @click="toQuery">{{ $t('common.btn.query') }}</el-button>-->
        <!--              <el-button type="primary" @click="reset">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>-->
        <!--            </el-form-item>-->
        <!--          </el-form>-->
        <!--        </div>-->
        <search-item
          ref="searchItem"
          config-module="402"
          :reset="true"
          :show-simple="false"
          :expand-adv="true"
          :custom-search-items="customSearchItems"
          :col-settings="{span:8}"
          grid-config-module="402001"
          @advSearchItemCallBack="toAdvancedQuery"
          @perConfigChange="value=>{perConfigName=value}"
          @refreshGrid="()=>{gridRefreshId+=1}"
        />
      </div>

      <div class="app-main-inner-row row-grid" style="min-height:350px;padding:0">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="height:300px"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          config-module="402001"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="app-main-inner-row row-pagination-right">
        <cargo-pagination
          v-show="searchConditions.total>0"
          config-module="150003"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchDataByPage"
        />
      </div>
      <div v-if="isFba" slot="footer" style="display: flex; justify-content: space-between;">
        <span>
          <b>{{ $t('SeaExport.QuantityOfSelectedOrder') }}：{{ selectedRows.length }}</b>
        </span>
        <div>
          <el-button type="primary" no="1" @click="add">{{ $t('SeaExport.Add3') }}</el-button>
          <el-button no="2" @click="closeHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </div>
      </div>
      <span v-if="!isFba" slot="footer" class="min-h" style="padding:10px;">
        <div style="float:right;">
          <el-button type="primary" no="3" @click="add">{{ $t('SeaExport.Add3') }}</el-button>
          <el-button no="4" @click="closeHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { complexQueryAeJobs, getAirExportJobsByLclMasterJob } from '@/api/AirExport/airExportJob'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { getLoading } from '@/utils/utilBaseElement'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'QueryAeLclDialog',
  components: { cargoAdvanceSelect, cargoCompanySelect, searchItem },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      filter: {
        jobNo: '',
        carrierId: 0,
        flight: '',
        customerId: 0,
        loadingPortCode: '',
        destinationPortCode: '',
        etdStart: '',
        etdEnd: '',
        branchId: 0
      },
      perConfigName: '',
      gridRefreshId: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onRowDataChanged: event => {
          this.onRowDataChanged(event)
        },
        onSelectionChanged: event => {
          // 触发多选
          this.onMultipleSelected(event)
        },
        context: {
          componentParent: this
        }
      },
      rowData: [],
      selectedRows: [],
      gridApi: null,
      searchConditions: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 10,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      customSearchItems: []
    }
  },
  computed: {
    isFba() { // 是否是FBA业务
      return this.job && this.job.fba
    },
    columnDefs() {
      return [
        {
          headerName: '',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
          field: 'jobNo',
          width: 130,
          colId: 'jobNo'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'customerId',
          width: 220,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          colId: 'customerId'
        }, {
          headerName: this.$t('CargoMsg.Cargo_DestinationAgent1'),
          field: 'destinationAgent',
          width: 180,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          colId: 'destinationAgent'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_POD'),
          field: 'destinationPortCode',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
          },
          colId: 'destinationPortCode'
        },
        {
          headerName: 'ETD',
          field: 'etd',
          width: 90,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          },
          colId: 'etd'
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantityContract',
          width: 70,
          colId: 'quantityContract'
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weightContract',
          width: 70,
          colId: 'weightContract'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Cubage'),
          field: 'cubageContract',
          width: 70,
          colId: 'cubageContract'
        }, {
          headerName: 'FBA',
          colId: 'fba',
          field: 'fba',
          initialHide: !this.isFba,
          suppressColumnsToolPanel: !this.isFba,
          width: 70,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Destination'),
          colId: 'fbaWarehouseCode',
          field: 'fbaWarehouseCode',
          initialHide: !this.isFba,
          suppressColumnsToolPanel: !this.isFba,
          width: 120
        }, {
          headerName: this.$t('queryJob.DomesticWarehouse'),
          colId: 'fbaWarehouseCmp',
          field: 'fbaWarehouseCmp',
          initialHide: !this.isFba,
          suppressColumnsToolPanel: !this.isFba,
          width: 120,
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_10') : ''
          }
        }, {
          headerName: this.$t('queryJob.ForeignWarehouse'),
          colId: 'overseaWarehouseCode',
          field: 'overseaWarehouseCode',
          initialHide: !this.isFba,
          suppressColumnsToolPanel: !this.isFba,
          width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_OverseaWarehouse, 'warehouseCode', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('queryJob.ExpectedTimeAtAmazonWarehouse'),
          colId: 'fbaPreAmazonWhTime',
          field: 'fbaPreAmazonWhTime',
          initialHide: !this.isFba,
          suppressColumnsToolPanel: !this.isFba,
          width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('queryJob.ReferenceBoxNumber'),
          colId: 'fbaRefContainerNo',
          field: 'fbaRefContainerNo',
          initialHide: !this.isFba,
          suppressColumnsToolPanel: !this.isFba,
          width: 120
        }, {
          headerName: 'Shipment Id',
          colId: 'fbaShipmentId',
          field: 'fbaShipmentId',
          initialHide: !this.isFba,
          suppressColumnsToolPanel: !this.isFba,
          width: 120
        },
        { headerName: this.$t('SeaExport.Operation'), field: 'op', width: 120, colId: 'op', hide: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op') : ''
          }
        }
      ]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initData()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        for (const key in this.filter) {
          this.filter[key] = ''
        }
        this.rowData = []
        this.selectedRows = []
        this.searchConditions.pageNum = 1
        this.searchConditions.total = 0
      }
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async initData() {
      await cache.load(cacheName.CONFIG)
      const isJyd = String(cache.config.get('ToExoSystem')) === 'JYD'
      const isAdmin = this.$store.getters.isAdmin
      // 头程主票加入小票高级查询
      // FBA
      let searchField = new AdvancedSearchField()
      searchField.multiple = 0
      searchField.defaultValue = true
      searchField.itemLabel = 'FBA'
      searchField.itemName = 'job.FBA'
      searchField.itemValue = ''
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.lock = true
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      this.customSearchItems.push(searchField.formatObj2Json())

      // 海外仓
      const overseaWarehouses = getCacheListByKey(basicCacheKeys.basic_data_OverseaWarehouse)
      // 目的地
      searchField = new AdvancedSearchField()
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.itemType = 'overseaWarehouse'
      searchField.fieldType = 'FIELD_OVERSEA_WAREHOUSE'
      searchField.subType = 'cascader'
      searchField.defaultConditionVal = '='
      searchField.itemName = 'fbaJob.WAREHOUSE_CODE'
      searchField.itemLabel = this.$t('CargoMsg.Cargo_Destination')
      searchField.tagName = 'warehouseCode'
      searchField.tagValue = 'warehouseCode'
      searchField.defaultSelected = 1
      searchField.dataProvider = overseaWarehouses
      this.customSearchItems.push(searchField.formatObj2Json())

      // 国内仓
      searchField = new AdvancedSearchField()
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.itemType = 'company'
      searchField.subType = {
        'type': 'warehouse',
        'tagValue': 'cmpIdx'
      }
      searchField.fieldType = 'FIELD_WAREHOUSE'
      searchField.itemName = 'fbaJob.DOMESTIC_WAREHOUSE'
      searchField.itemLabel = this.$t('queryJob.DomesticWarehouse')
      searchField.defaultSelected = 0
      searchField.dataProvider = []
      this.customSearchItems.push(searchField.formatObj2Json())

      // 国外仓
      searchField = new AdvancedSearchField()
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'job.OVERSEA_WAREHOUSE_CODE'
      searchField.itemLabel = this.$t('queryJob.ForeignWarehouse')
      searchField.tagName = 'countryChineseName'
      searchField.tagValue = 'warehouseCode'
      searchField.defaultSelected = 0
      searchField.dataProvider = overseaWarehouses.filter(p => !p.ifFba)
      this.customSearchItems.push(searchField.formatObj2Json())

      // 预期入亚马逊仓时间
      searchField = new AdvancedSearchField()
      searchField.itemType = 'date'
      searchField.itemCondition = []
      searchField.defaultConditionVal = 'RANGE'
      searchField.fieldType = 'FIELD_DATE_RANGE'
      searchField.itemName = 'fbaJob.PRE_AMAZON_WH_TIME'
      searchField.itemLabel = 'FbaJob.PreAmazonWhTime'
      searchField.subType = 'range'
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = []
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // 中文品名
      searchField = new AdvancedSearchField()
      searchField.itemType = 'input'
      searchField.subType = ''
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'job.CARGO_CHINESE_NAME'
      searchField.itemLabel = 'SeaExport.ChineseDescriptionOfGoods'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // 英文品名
      searchField = new AdvancedSearchField()
      searchField.itemType = 'input'
      searchField.subType = ''
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'job.CARGO_ENGLISH_NAME'
      searchField.itemLabel = 'SeaExport.EnglishDescriptionOfGoods'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // 参考箱号
      searchField = new AdvancedSearchField()
      searchField.itemType = 'input'
      searchField.subType = ''
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'warehouseIn.REF_CONTAINER_NO'
      searchField.itemLabel = 'Warehouse.RefContainerNo'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // Shipment Id
      searchField = new AdvancedSearchField()
      searchField.itemType = 'input'
      searchField.subType = ''
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'fbaJob.SHIPMENT_ID'
      searchField.itemLabel = 'FbaJob.ShipmentId'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())
      // 操作部门使用主票操作部门，且不可编辑
      searchField = new AdvancedSearchField()
      searchField.itemType = 'department5'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_DEPARTMENT5'
      searchField.itemName = 'job.OP_DEPARTMENT'
      searchField.itemLabel = 'SeaExport.OperationDepartment'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.lock = true
      searchField.defaultValue = [this.job.opDepartment]
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // CARGO-42713 加入小票查询权限逻辑优化-只能操作看自己的
      searchField = new AdvancedSearchField()
      searchField.itemType = 'user'
      searchField.subType = {
        'category': 'role',
        'shape': 'op'
      }
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_USER'
      searchField.itemName = 'job.OP_ID'
      searchField.itemLabel = 'SeaExport.Operation'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.lock = (isJyd && !isAdmin)
      searchField.defaultValue = (isJyd && !isAdmin) ? this.$store.getters.userId : 0
      searchField.action = this.isFba ? AdvancedSearchField.REMOVE_ACTION : AdvancedSearchField.UPDATE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())
    },
    toQueryForFba(conditions) {
      this.selectedRows = []
      if (typeof conditions === 'undefined' || !conditions || conditions.length === 0) {
        conditions = []
      }
      if (this.job.opDepartment && this.job.opDepartment > 0) {
        conditions.push(new AdvancedSearchOption(null, 'job.OP_DEPARTMENT', this.job.opDepartment, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
      }
      conditions.push(new AdvancedSearchOption(null, 'job.FBA', this.isFba, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
      conditions.push(new AdvancedSearchOption(null, 'airJob.OPERATE_TYPE', 0, OperatorConstants.OPERATOR_EQUAL.code))
      this.loading = getLoading('search')
      getAirExportJobsByLclMasterJob({ conditions, branchId: this.$store.getters.currentOfficeId, pageNum: this.searchConditions.pageNum, pageSize: this.searchConditions.pageSize }).then(res => {
        this.rowData = []
        if (res.data) {
          this.rowData = res.data
        }
        this.searchConditions.total = res.data && res.data.length > 0 ? Number(res.data.length) : 0
      }).finally(() => {
        this.loading.close()
      })
    },
    // 分页触发查询
    fetchDataByPage() {
      this.toQuery(this.searchConditions.snapshotConditions)
    },
    toAdvancedQuery(data) {
      this.searchConditions.pageNum = 1
      this.toQuery(data)
    },
    toQuery(data) {
      this.selectedRows = []
      this.filter.branchId = this.$store.getters.currentOfficeId
      const conditions = data
      // CARGO-28997 【加入小票】优化前端提示
      // if (filter.jobNo) {
      //   const condition = new AdvancedSearchOption(null, filter.jobNo.length > 5 ? 'job.JOB_NO' : 'job.JOB_NO5', filter.jobNo, OperatorConstants.OPERATOR_LIKE.code)
      //   conditions.push(condition.formatObj2Json())
      // }
      // if (filter.carrierId) {
      //   const condition = new AdvancedSearchOption(null, 'job.CARRIER_ID', filter.carrierId, OperatorConstants.OPERATOR_EQUAL.code)
      //   conditions.push(condition.formatObj2Json())
      // }
      // if (filter.flight) {
      //   const condition = new AdvancedSearchOption(null, 'job.VOYAGE_FLIGHT', filter.flight, OperatorConstants.OPERATOR_EQUAL.code)
      //   conditions.push(condition.formatObj2Json())
      // }
      // if (filter.customerId) {
      //   const condition = new AdvancedSearchOption(null, 'job.CUSTOMER_ID', filter.customerId, OperatorConstants.OPERATOR_EQUAL.code)
      //   conditions.push(condition.formatObj2Json())
      // }
      // if (filter.loadingPortCode) {
      //   const condition = new AdvancedSearchOption(null, 'job.LOADING_PORT_CODE', filter.loadingPortCode, OperatorConstants.OPERATOR_EQUAL.code)
      //   conditions.push(condition.formatObj2Json())
      // }
      // if (filter.destinationPortCode) {
      //   const condition = new AdvancedSearchOption(null, 'job.DESTINATION_PORT_CODE', filter.destinationPortCode, OperatorConstants.OPERATOR_EQUAL.code)
      //   conditions.push(condition.formatObj2Json())
      // }
      // let inputDate = ''
      // if (filter.etdStart && filter.etdEnd) {
      //   inputDate = 'start=' + filter.etdStart + ' 00:00:00' + ',end=' + filter.etdEnd + ' 23:59:59'
      // } else if (filter.etdStart && !filter.etdEnd) {
      //   inputDate = 'start=' + filter.etdStart + ' 00:00:00'
      // } else if (!filter.etdStart && filter.etdEnd) {
      //   inputDate = 'end=' + filter.etdEnd + ' 23:59:59'
      // }
      // if (inputDate) {
      //   const condition = new AdvancedSearchOption(null, 'job.ETD', inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
      //   conditions.push(condition.formatObj2Json())
      // }
      // const condition1 = new AdvancedSearchOption(null, 'airExportJob.OPERATE_TYPE', 0, OperatorConstants.OPERATOR_EQUAL.code)
      // conditions.push(condition1.formatObj2Json())
      // const condition2 = new AdvancedSearchOption(null, 'job.MASTER_FLAG', 0, OperatorConstants.OPERATOR_EQUAL.code)
      // conditions.push(condition2.formatObj2Json())
      // const condition3 = new AdvancedSearchOption(null, 'job.MBL', '', OperatorConstants.OPERATOR_IS_NULL.code)
      // conditions.push(condition3.formatObj2Json())
      // const condition4 = new AdvancedSearchOption(null, 'job.LCL_MASTER_UUID', '', OperatorConstants.OPERATOR_IS_NULL.code)
      // conditions.push(condition4.formatObj2Json())
      // CARGO-34019 空运订舱加入小票，可以查到空运头程的业务
      const containerFba = conditions.find(obj => obj.fieldName === 'job.FBA')
      if (!containerFba) {
        conditions.push(new AdvancedSearchOption(null, 'job.FBA', this.isFba, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
      }
      this.searchConditions.snapshotConditions = [...conditions]
      this.loading = getLoading('search')
      complexQueryAeJobs({ conditions, branchId: this.$store.getters.currentOfficeId, pageNum: this.searchConditions.pageNum, pageSize: this.searchConditions.pageSize }).then(res => {
        this.rowData = []

        if (res.data && res.data.list) {
          this.rowData = res.data.list
        }
        this.searchConditions.total = res.data.total ? Number(res.data.total) : 0
      }).finally(() => {
        this.loading.close()
      })
    },
    onRowDataChanged(event) {
      // 重置（多选）选中行
      this.selectedRows = []
    },
    onMultipleSelected() {
      this.selectedRows = this.gridApi.getSelectedRows()
    },
    async add() {
      const selectedRows = this.selectedRows // 记录当前选中的记录，避免后续被修改
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.info(this.$t('Message.SelectTheData'))
        return
      }
      for (const job of selectedRows) {
        if (job.lclMasterUuid) {
          this.$message.warning(job.jobNo + ' ' + this.$t('Message.HasJoinIntoMbl'))
          return
        }
      }
      const triggerCallback = () => {
        this.$emit('attachSubJobCallBackHandler', selectedRows)
        this.innerVisible = false
      }
      if (!(await this.hasDiffField(selectedRows))) {
        this.$confirm(this.$t('Message.TheHAWBAndMAWBAreInconsistentTheSystemWillModifyTheHAWBContinue'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          triggerCallback()
        }).catch(() => { })
      } else {
        triggerCallback()
      }
    },
    async hasDiffField(selectedRows) {
      for (const slave of selectedRows) {
        if (slave.destinationAgent !== this.job.destinationAgent) {
          return false
        }
        if (slave.loadingPortCode !== this.job.loadingPortCode) {
          return false
        }
        if (slave.destinationPortCode !== this.job.destinationPortCode) {
          return false
        }
        if (slave.bookingAgent !== this.job.bookingAgent) {
          return false
        }
        if (slave.carrierId !== this.job.carrierId) {
          return false
        }
        if (slave.flight !== this.job.flight) {
          return false
        }
        if (slave.etd !== this.job.etd) {
          return false
        }
        if (slave.bookingTerm !== this.job.bookingTerm) {
          return false
        }
        if (slave.paymentTermMBL !== this.job.paymentTermMBL) {
          return false
        }
      }
      return true
    },
    closeHandler() {
      this.innerVisible = false
    }
  }
}
</script>

<style lang="scss">
  .search {
    label {
      font-size: 12px;
      font-weight: normal;
    }
    .el-select {
      width: 100%;
    }
    .el-dialog__footer {
      min-height: 45px;
    }
  }
</style>
